import { IPhotoModel } from '@common/models';
import { ImageResizerUtil } from '@common/utils';
import classNames from 'classnames';
import { toNumber } from 'lodash';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { Image } from 'react-bootstrap';
import { PhotoUtils } from '.';

export interface IAttachmentPhotoProps {
  photo?: IPhotoModel;
  fileName: string;
}

export const AttachmentPhoto = observer(
  ({
    photo,
    fileName,
    height,
    width,
    className,
    ...attrs
  }: IAttachmentPhotoProps & React.ImgHTMLAttributes<HTMLImageElement>) => {
    const lHeight = toNumber(height ? height : 150);
    const lWidth = toNumber(width ? width : 150);
    const photoUrl = useMemo(
      () =>
        ImageResizerUtil.getAzureImageUrlByPhoto(photo, {
          mode: 'pad',
          height: lHeight,
          width: lWidth,
        }),
      [photo, lHeight, lWidth],
    );
    const imageSize = PhotoUtils.getImageSize(width, height, undefined, photo);

    return (
      <>
        {photo && (
          <a
            href={photo?.photoUrl}
            title={fileName}
            target="_blank"
            rel="noreferrer noopener"
          >
            <Image
              className={classNames(className)}
              src={photoUrl}
              alt={`photo of upload ${fileName}`}
              height={imageSize.height}
              width={imageSize.width}
              {...attrs}
            />
          </a>
        )}
      </>
    );
  },
);
